import script from "./PaginationV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationV2.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationV2.vue?vue&type=style&index=0&id=51221f61&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3818363008/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51221f61"]])

export default __exports__